import ReactExport from "react-export-excel";
import React from "react";
import { Dropdown } from "react-bootstrap";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const InventoryDetailsExcelToRenderOverallComponent = (
  data,
  filename
) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Inventory details">
      <ExcelColumn label="Cluster Name" value={(r) => r.clusterName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}
      <ExcelColumn
        label="Active Pcs"
        value={(r) => r.totalPiecesDetails.active}
      />
      <ExcelColumn
        label="Active Amt"
        value={(r) => r.totalPrincipalDetails.active}
      />
      <ExcelColumn
        label="Overdue Pcs"
        value={(r) => r.totalPiecesDetails.expired}
      />
      <ExcelColumn
        label="Overdue Amt"
        value={(r) => r.totalPrincipalDetails.expired}
      />
      <ExcelColumn
        label="% OD Pcs"
        value={(r) => r.totalPiecesDetails.expiredPercentage}
      />
      <ExcelColumn
        label="% OD Amt"
        value={(r) => r.totalPrincipalDetails.expiredPercentage}
      />
      <ExcelColumn label="Total Pcs" value={(r) => r.totalPieces} />
      <ExcelColumn label="Total Amt" value={(r) => r.totalPrincipal} />
      <ExcelColumn
        label="Ave/Amt/Pcs"
        value={(r) => r.averagePrincipalPerPiece}
      />
    </ExcelSheet>
  </ExcelFile>
);

export const InventoryDetailsExcelToRenderAreaComponent = (data, filename) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Inventory details">
      <ExcelColumn label="Branch Name" value={(r) => r.areaName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}
      <ExcelColumn
        label="Active Pcs"
        value={(r) => r.totalPiecesDetails.active}
      />
      <ExcelColumn
        label="Active Amt"
        value={(r) => r.totalPrincipalDetails.active}
      />
      <ExcelColumn
        label="Overdue Pcs"
        value={(r) => r.totalPiecesDetails.expired}
      />
      <ExcelColumn
        label="Overdue Amt"
        value={(r) => r.totalPrincipalDetails.expired}
      />
      <ExcelColumn
        label="% OD Pcs"
        value={(r) => r.totalPiecesDetails.expiredPercentage}
      />
      <ExcelColumn
        label="% OD Amt"
        value={(r) => r.totalPrincipalDetails.expiredPercentage}
      />
      <ExcelColumn label="Total Pcs" value={(r) => r.totalPieces} />
      <ExcelColumn label="Total Amt" value={(r) => r.totalPrincipal} />
      <ExcelColumn
        label="Ave/Amt/Pcs"
        value={(r) => r.averagePrincipalPerPiece}
      />
    </ExcelSheet>
  </ExcelFile>
);

export const InventoryDetailsExcelToRenderBranchComponent = (
  data,
  filename
) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Daily Report">
      <ExcelColumn label="Branch Code" value={(r) => r.branchCode} />
      <ExcelColumn label="Branch Name" value={(r) => r.branchName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}
      <ExcelColumn
        label="Active Pcs"
        value={(r) => r.totalPiecesDetails.active}
      />
      <ExcelColumn
        label="Active Amt"
        value={(r) => r.totalPrincipalDetails.active}
      />
      <ExcelColumn
        label="Overdue Pcs"
        value={(r) => r.totalPiecesDetails.expired}
      />
      <ExcelColumn
        label="Overdue Amt"
        value={(r) => r.totalPrincipalDetails.expired}
      />
      <ExcelColumn
        label="% OD Pcs"
        value={(r) => r.totalPiecesDetails.expiredPercentage}
      />
      <ExcelColumn
        label="% OD Amt"
        value={(r) => r.totalPrincipalDetails.expiredPercentage}
      />
      <ExcelColumn label="Total Pcs" value={(r) => r.totalPieces} />
      <ExcelColumn label="Total Amt" value={(r) => r.totalPrincipal} />
      <ExcelColumn
        label="Ave/Amt/Pcs"
        value={(r) => r.averagePrincipalPerPiece}
      />
    </ExcelSheet>
  </ExcelFile>
);
